import React, { Component } from "react";
import { Box, Typography } from "@mui/material";
import { Trans, withTranslation } from 'react-i18next';
import { CommonNavigationHeader } from "../../../Components/Common Components/CommonComponents";
import "./inventory.css"
import StockList from "./StockList";
import ActiveInventory from "./ActiveInventory";
import InActiveInventory from "./InActiveInventory";
import NoMovement from "./NoMovement";
import StockExpiry from "./StockExpiry";
import NewDrug from "./NewDrug";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import ExpiredStock from "./ExpiredStock";
import { CheckAccessFunc } from "../../../Components/CommonFunctions/CommonFunctions";
import { hasAccess } from "../../../Utility/AccessUtils";
import { localGetItem } from "../../../Utility/Services/CacheProviderService";
import { ImagePaths } from "../../../Utility/ImagePaths";



const navigationHeaderList = [
    { id: 0, TabName: "Stock List", value: "stockList" },
    { id: 1, TabName: "Active Inventory", value: "activeList" },
    { id: 2, TabName: "Inactive Inventory", value: "inActiveList" },
    { id: 3, TabName: "No movement Inventory", value: "noMovementList" },
    { id: 4, TabName: "Short Expiry Stock", value: "shortExpiryList" },
    { id: 5, TabName: "New Product Status", value: "newDrugList" },
    { id: 6, TabName: "Expired Stock", value: "expiredStock"}
]
class Inventory extends Component {
    // Helper function to check access for inventory tabs
    // Uses hasAccess from AccessUtils for simplified package-based access control
    checkInventoryTabAccess = (tabName) => {
        const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo') || '{}');
        const role = loggedInUserInfo?.is_super_admin ? "admin" : (loggedInUserInfo?.is_branch_admin ? "admin" : "user");
        
        // Map tab names to routes for hasAccess check
        const tabRouteMap = {
            "Stock List": "/Inventory/StockList",
            "Active Inventory": "/Inventory/ActiveInventory",
            "Inactive Inventory": "/Inventory/InactiveInventory",
            "No Movement Inventory": "/Inventory/NoMovementInventory",
            "Short Expiry Stock": "/Inventory/ShortExpiryStock",
            "New Product Status": "/Inventory/NewProductStatus",
            "Expired Status": "/Inventory/ExpiredStock"
        };
        
        const route = tabRouteMap[tabName];
        
        // For users, also check CheckAccessFunc for user-level permissions
        if (role === "user") {
            const checkAccessResult = CheckAccessFunc("Laboratory", "Inventory", tabName, null, "Tab");
            if (checkAccessResult?.viewAccess === false) {
                return {
                    viewAccess: false,
                    is_locked: checkAccessResult?.is_locked || false
                };
            }
        }
        
        // Use hasAccess for package-based access control
        if (route) {
            const accessResult = hasAccess(null, role, route);
            return {
                viewAccess: accessResult.allowed,
                is_locked: accessResult.locked
            };
        }
        
        // Fallback to CheckAccessFunc if no route mapping
        const checkAccessResult = CheckAccessFunc("Laboratory", "Inventory", tabName, null, "Tab");
        return {
            viewAccess: checkAccessResult?.viewAccess !== false,
            is_locked: checkAccessResult?.is_locked || false
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            selectedScreen: "stockList",
            showSuccessResponse: false,
            showErrorResponse:false ,
            responseMessage: "",
            selectedTabID: 0,
            stock_search:'',
            active_search:'',
            inactive_search:'',
            no_mov_search:'',
            quick_expiry_search:'',
            new_product_search:'',
            common_search:''
        }
    }

    componentDidMount(){
        this.props.changeScreen('3')
        this.props.subScreenChange("Inventory")
    }

    componentWillReceiveProps(props){
        let {selectedScreen} = this.state
        if(props.inventorySearch !== this.state.common_search){
            this.setState({
                common_search : props.inventorySearch
            })
            if(selectedScreen === "stockList"){
                this.setState({
                    stock_search : props.inventorySearch
                })
            }else if(selectedScreen === "activeList"){
                this.setState({
                    active_search : props.inventorySearch
                })
            }else if(selectedScreen === "inActiveList"){
                this.setState({
                    inactive_search : props.inventorySearch
                })
            }else if(selectedScreen === "noMovementList"){
                this.setState({
                    no_mov_search : props.inventorySearch
                })
            }else if(selectedScreen === "shortExpiryList"){
                this.setState({
                    quick_expiry_search : props.inventorySearch
                })
            }else if(selectedScreen === "newDrugList"){
                this.setState({
                    new_product_search : props.inventorySearch
                })
            }else if(selectedScreen === 'expiredStock'){
                this.setState({
                    expired_stock : props.inventorySearch
                })
            }
        }
    }

    msgClose(){
        this.setState({
            showSuccessResponse: false,
            showErrorResponse:false ,
            responseMessage: "",
        })
    }

    NavigateScreen(id) { 
        this.setState({
            selectedScreen: navigationHeaderList[id].value,
            selectedTabID: id
        })
        this.props.subScreenChange(navigationHeaderList[id].value)
        this.props.clrSearch()
    }

    selectedTab = (value) => {
        this.props.subScreenChange("")
        this.setState({
            selectedScreen: "stockList",
            selectedTabID: 0
        })
    }

    responseSuccessErrorMessage(message, type) {
        this.setState({
            showSuccessResponse: message ? type : false,
            showErrorResponse: message ? !type : false,
            responseMessage: message
        })
    }
    // Helper to render content based on access
    renderInventoryContent = () => {
        const { selectedScreen } = this.state;
        const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo') || '{}');
        const isAdmin = loggedInUserInfo?.is_super_admin || loggedInUserInfo?.is_branch_admin;
        
        // Map screen to tab name for access check
        const screenToTabMap = {
            "stockList": "Stock List",
            "activeList": "Active Inventory",
            "inActiveList": "Inactive Inventory",
            "noMovementList": "No Movement Inventory",
            "shortExpiryList": "Short Expiry Stock",
            "newDrugList": "New Product Status",
            "expiredStock": "Expired Status"
        };
        
        const tabName = screenToTabMap[selectedScreen];
        if (!tabName) {
            return <Typography className='eMed_NoAccess_Text' sx={{paddingTop:"13vw"}}>No Access For This Screen</Typography>;
        }
        
        const access = this.checkInventoryTabAccess(tabName);
        const isLocked = access?.is_locked === true;
        const hasViewAccess = access?.viewAccess === true;
        
        // For admin: show lock screen if locked
        if (isAdmin && isLocked) {
            return (
                <Box sx={{ height: '70vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'white' }}>
                    <img src={ImagePaths.LockScreen.default} alt="Lock" />
                    <Typography sx={{ marginTop: '1vw', fontSize: '1.2vw', fontWeight: 600 }}>This feature is locked.</Typography>
                    <Typography sx={{ marginTop: '0.5vw', fontSize: '0.9vw', color: '#666' }}>Please contact your administrator to unlock this feature.</Typography>
                </Box>
            );
        }
        
        // For user: show no access if locked or no viewAccess
        if (!isAdmin && (isLocked || !hasViewAccess)) {
            return <Typography className='eMed_NoAccess_Text' sx={{paddingTop:"13vw"}}>No Access For This Screen</Typography>;
        }
        
        // Show the actual component
        switch (selectedScreen) {
            case "stockList":
                return <StockList search_key={this.state.stock_search} NavigateScreen={this.NavigateScreen.bind(this)} responseSuccessErrorMessage={this.responseSuccessErrorMessage.bind(this)} />;
            case "activeList":
                return <ActiveInventory search_key={this.state.active_search} responseSuccessErrorMessage={this.responseSuccessErrorMessage.bind(this)} />;
            case "inActiveList":
                return <InActiveInventory search_key={this.state.inactive_search} responseSuccessErrorMessage={this.responseSuccessErrorMessage.bind(this)} />;
            case "noMovementList":
                return <NoMovement search_key={this.state.no_mov_search} responseSuccessErrorMessage={this.responseSuccessErrorMessage.bind(this)} />;
            case "shortExpiryList":
                return <StockExpiry search_key={this.state.quick_expiry_search} responseSuccessErrorMessage={this.responseSuccessErrorMessage.bind(this)} />;
            case "newDrugList":
                return <NewDrug search_key={this.state.new_product_search} responseSuccessErrorMessage={this.responseSuccessErrorMessage.bind(this)} selectedTab={this.selectedTab} />;
            case "expiredStock":
                return <ExpiredStock search_key={this.state.expired_stock} />;
            default:
                return <Typography className='eMed_NoAccess_Text' sx={{paddingTop:"13vw"}}>No Access For This Screen</Typography>;
        }
    }

    render() {
        const { t } = this.props
        let {showSuccessResponse, showErrorResponse, responseMessage } = this.state
        return (
            <Box id = "emedhub_inventory_Container">
                <CommonNavigationHeader menu = {navigationHeaderList} NavigateScreen = {this.NavigateScreen.bind(this)} selectedTabID = {this.state.selectedTabID} />
                <div>
                    {this.renderInventoryContent()}
                </div>
                {
                    showSuccessResponse ? <ToastMsg severity = {"success"} msg = {responseMessage} msgPop={this.msgClose.bind(this)}/> : null
                }
                { 
                    showErrorResponse ? <ToastMsg severity = {"error"} msg = {responseMessage} msgPop={this.msgClose.bind(this)}/> : null
                }
            </Box>
        )
    }
}

export default withTranslation()(Inventory);